const SOUND_BASE = '/demo/red-envelope/sounds'

const cache = new Map<string, HTMLAudioElement>()

function playClip(name: string, volume: number, playbackRate = 1) {
  const src = `${SOUND_BASE}/${name}`
  let audio = cache.get(src)
  if (!audio) {
    audio = new Audio(src)
    cache.set(src, audio)
  }
  const clip = audio.cloneNode(true) as HTMLAudioElement
  clip.volume = Math.min(1, Math.max(0, volume))
  clip.playbackRate = playbackRate
  void clip.play().catch(() => {})
}

/** กดเลือกซอง — เบา */
export function playRedEnvelopeClick() {
  playClip('click.ogg', 0.38)
}

/** เปิดซอง — ใช้เสียงโชว์ยอดจาก C3 แทน slot lever (แสบหู) */
export function playRedEnvelopeOpen() {
  playClip('show-amount.webm', 0.42)
}

/** ไล่เลข — ติ๊กเบา */
export function playRedEnvelopeRollTick() {
  playClip('click.ogg', 0.2, 1.15)
}

/** หน้าสรุป */
export function playRedEnvelopeSummary() {
  playClip('win-soft.webm', 0.5)
}
